const actionTypeIdentifier = '0F370BD9-4D21-425C-B515-377C213AD8CE';

export const getCircuitEquipList = `GET-CIRCUIT-EQUIP-LIST-${actionTypeIdentifier}`;
export const deleteCircuitEquipItem = `DELETE-CIRCUIT-EQUIP-ITEM-${actionTypeIdentifier}`;
export const addCircuitEquipItem = `ADD-CIRCUIT-EQUIP-ITEM-${actionTypeIdentifier}`;
export const updateCircuitEquipItem = `UPDATE-CIRCUIT-EQUIP-ITEM-${actionTypeIdentifier}`;
export const resetCircuitEquipDetails = `RESET-CIRCUIT-EQUIP-DETAILS-${actionTypeIdentifier}`;
export const onServiceModelSelect = `SET-CIRCUIT-EQUIP-SELECT-${actionTypeIdentifier}`;

export const circuitEquipFormModel = {
    ID: -1,
    TypeId: null,
    Type: null,
    Model: null,
    ModelId: null,
    IMEISerialNumber: null,
    AssetTagNumber: "",
    StatusId: null,
    Status: null,
    ProductName: null,
    PartCode: "",
    Price: "0.00",
    AdditionalInformation: ""
}